import ReportMessage from "./ReportMessage";
import DemoQuantifications from "./DemoQuantifications";
import CropDisplay from "./CropDisplay";
import { useStore } from 'react-redux';
import G from './Getters';
import Barplot, { getDefaultColorOrder } from './Barplot';
import O from './O';

export default function SignalLoadingControlPlot({value,replicate,target,type}){


  const store = useStore();
  const state = store.getState();



  let targetId = replicate.annotationId;
  let controlId = replicate.control;



  const colorOrder = getDefaultColorOrder();

  const cropWidth = 300;
  const labelWidth = 80;

  let annotationIds = [targetId, controlId]
  
  let quantifications = annotationIds.map(id => DemoQuantifications.find(v => v.annotationId === id)?.values).filter(x => x);

 
  let labels = annotationIds.map(atnId => G.getAnnotationLabel(state,atnId));
  let [targetLabel,controlLabel] = labels;


  const order = annotationIds.map((annotationId,ii) => {

    let label = labels[ii];



    return (
      <div style={{marginTop:10}} class="sg-row">

        <div class="sg-row v-center" style={{justifyContent:'flex-end',width:labelWidth}}>
          <div>{label}</div>
          <div style={{margin:3,height:'75%',width:5,
            background:colorOrder[ii]
            }}/>
        </div>
        <div class="rel" style={{width:cropWidth }}>

          
          <CropDisplay {...{annotationId, width:cropWidth}}/>
          

        </div>
      </div>
    )

  });



  let message;
  if( type === "saturation" ){

    message = (
      <ReportMessage style={{margin:10}} type={"success"}>

        <b>Loading Control In Linear Range</b>
        <div>The captured signal, in linear range, is appropriate for further analysis.</div>
      </ReportMessage>
    )
    
  }else{

    message = (
      <ReportMessage style={{margin:10}} type={"alert"}>

        <b>{`Uneven Loading Control (${controlLabel})`}</b>
        <div>Any comparison requires normalization by loading control.</div>
      </ReportMessage>
    )
    
  }

  

  return (
    <div style={{width:500}}>

      <div style={{fontSize:24, textAlign:'center'}}>{replicate.label}</div>

      {message}
     
      
      <div class="rel" style={{width:cropWidth,marginLeft:labelWidth}}>
        <Barplot values={quantifications}/>
      </div>
      {order}
    </div>
  )

}
